<template>
  <div class="dashboard-layout23">
    <div class="content-container23">
      <div class="card-container23">
        <div class="titolo-card">
          <h1>PAGINA NON AUTORIZZATA</h1>
        </div>
        <div class="card-image23">
          <img src="https://www.metodofusco.it/media/image%20pange%20non%20autorizzata.png" alt="Descrizione dell'immagine">
        </div>
    
      </div>
    </div>
  </div>
</template>



<script>



    

</script>




  
<style scoped>
.dashboard-layout23 {
  background-color: #111111; /* Sostituisci con il colore di sfondo che preferisci */
  display: flex;
  justify-content: center; /* Centra orizzontalmente */
  height: 100vh; /* Assicura che .dashboard-layout occupi l'intera altezza della viewport */
}

.content-container23 {
  text-align: center; /* Centra il testo del titolo */
}

.card-container23 {
  display: flex;
  flex-direction: column; /* Organizza i contenuti verticalmente */
  align-items: center; /* Centra gli elementi figli (titolo e immagine) orizzontalmente */
  padding: 20px; /* Aggiunge un po' di spazio intorno ai contenuti per una migliore presentazione */
}

.card-image23 img {
  max-width: 100%; /* Assicura che l'immagine non superi la larghezza del suo contenitore */
  height: auto; /* Mantiene l'aspect ratio dell'immagine */
}

</style>
